import { AppError } from "@/domain/errors/AppError";

export class UseCaseError extends AppError {
  readonly isOperational = true;

  constructor(
    message: string,
    readonly code = "USE_CASE_FAILED",
  ) {
    super(message);
  }
}
